import { ClientAttributesSelectorModel } from '@/app/core/components/client-attributes';
import { EmptyResponse } from '@ssar-app/domain';

export const cacheClientAttributesForStepWizard = (
  dependentData: EmptyResponse,
  clientAttributesModel?: ClientAttributesSelectorModel,
) => {
  const toReturn = { ...dependentData };
  toReturn['clientAttributesModel'] = clientAttributesModel;
  return toReturn;
};
